// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ji-1";
export var messageSideRight = "_ji-2";
export var subscribeToBackInStockBubbleContainer = "_ji-0";